export default (prefixedValue, value, keepUnprefixed) => keepUnprefixed ? [ prefixedValue, value ] : prefixedValue
